import { useDispatch, useSelector } from "react-redux";
import Footer from "../../../components/Footer";
import SubHeader from "../../../components/SubHeader";
import { setCreatorMode } from "../../../store/editorSlice";
import { CreatorMode } from "../../../types/editorModeEnum";
import { RoleClassEnum } from "../../../types/roleClassEnum";
import { useEffect, useState } from "react";
import { MAFIA_ROLE_GROUPS, MAFIA_ROLES, NEUTRAL_ROLE_GROUPS, NEUTRAL_ROLES, TOWN_ROLE_GROUPS, TOWN_ROLES } from "../../../types/roleEnum";
import { RootState } from "../../../store/store";
import ScenarioUtils from "../../../utils/scenarioUtils";

function RoleRowSetup(props: { rowString: string, onSave: (editedString: string) => void }) {
    const dispatch = useDispatch();
    const { creatorMode } = useSelector((state: RootState) => state.editor);
    const { rowString, onSave } = props;
    const [roleArray, setRoleArray] = useState<string[]>([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [roleClass, setRoleClass] = useState(RoleClassEnum.Town);

    useEffect(() => {
        const currentRole = ScenarioUtils.CheckRole(rowString);
        setRoleClass(currentRole);

        const arr = [] as string[];
        const rowStringTrimmed = rowString.split(/\s/).join('');

        let currString = '';
        for (let i = 0; i < rowStringTrimmed.length; i++) {
            if (rowStringTrimmed[i] === '+') {
                arr.push(currString);
                arr.push('+');
                currString = '';
            } else if (rowStringTrimmed[i] === '-') {
                arr.push(currString);
                arr.push('-');
                currString = '';
            } else {
                currString += rowStringTrimmed[i];
            }
            if (i === rowStringTrimmed.length - 1) {
                arr.push(currString);
            }
        }

        setRoleArray(arr);
    }, []);

    const getFirstEl = () => {
        switch (roleClass) {
            case RoleClassEnum.Town:
                return TOWN_ROLES[0];
            case RoleClassEnum.Mafia:
                return MAFIA_ROLES[0];
            case RoleClassEnum.Neutral:
            default:
                return NEUTRAL_ROLES[0];
        }
    }

    const onSaveClick = () => {
        onSave(roleArray.join(' '));
        dispatch(setCreatorMode(CreatorMode.SetupRoles));
    }



    const setCurrentRoleValue = (value: string | string[], index: number) => {
        let clone = [...roleArray];

        if (typeof value === 'string') {
            if (index >= clone.length) {
                clone.push(value);
            } else {
                clone[index] = value;
            }
        } else {
            if (index >= clone.length) {
                clone = clone.concat(value);
            } else {
                for (var i = 0; i < value.length; i++) {
                    clone[index + i] = value[i];
                }
            }
        }
        setRoleArray(clone);
    }

    const removeRoleValue = (index: number, count: number) => {
        let clone = [...roleArray];
        clone.splice(index, count);
        setRoleArray(clone);
    }

    const getRoleSelector = () => {
        const getList = () => {
            switch (roleClass) {
                case RoleClassEnum.Town:
                    return TOWN_ROLE_GROUPS.concat(TOWN_ROLES);
                case RoleClassEnum.Mafia:
                    return MAFIA_ROLE_GROUPS.concat(MAFIA_ROLES);
                case RoleClassEnum.Neutral:
                default:
                    return NEUTRAL_ROLE_GROUPS.concat(NEUTRAL_ROLES);
            }
        }

        const onRoleSelectorCancel = () => {
            dispatch(setCreatorMode(CreatorMode.SetupRoleRow));
        }

        const onRoleSelectorPick = (e: any) => {
            setCurrentRoleValue(e.target.value as string, currentIndex);
            dispatch(setCreatorMode(CreatorMode.SetupRoleRow));
        }

        return <div className="mafia-role-selector-wrapper">
            <div className="mafia-role-selector-header">Pick a role</div>
            <div className="mafia-role-tabs">
                <div className={`mafia-role-tab ${roleClass === RoleClassEnum.Town ? 'selected' : ''}`} onClick={() => setRoleClass(RoleClassEnum.Town)}>Town</div>
                <div className={`mafia-role-tab ${roleClass === RoleClassEnum.Mafia ? 'selected' : ''}`} onClick={() => setRoleClass(RoleClassEnum.Mafia)}>Mafia</div>
                <div className={`mafia-role-tab ${roleClass === RoleClassEnum.Neutral ? 'selected' : ''}`} onClick={() => setRoleClass(RoleClassEnum.Neutral)}>Other</div>
            </div>
            <div className="mafia-role-selector" >
                {
                    getList().map(roleString => {
                        const cl = roleArray.indexOf(roleString) !== -1 ? 'selected' : ''
                        return <div className={`mafia-role-button ${cl}`}>
                            <button value={roleString} onClick={onRoleSelectorPick}>{roleString}</button>
                        </div>
                    })
                }
            </div>
            <div className="mafia-role-selector-footer"><button onClick={onRoleSelectorCancel}>Cancel</button></div>
        </div>
    }

    const onRoleClick = (index: number) => {
        setCurrentIndex(index);
        dispatch(setCreatorMode(CreatorMode.SetupSingleRoleRow));
    }

    const onPlusClick = (index: number) => {
        setCurrentRoleValue('+', index);
        dispatch(setCreatorMode(CreatorMode.SetupRoleRow));
    };
    const onMinusClick = (index: number) => {
        setCurrentRoleValue('-', index);
        dispatch(setCreatorMode(CreatorMode.SetupRoleRow));
    };

    const onNewClick = (plusMinus: string) => {
        setCurrentRoleValue([plusMinus, getFirstEl()], roleArray.length);
        dispatch(setCreatorMode(CreatorMode.SetupRoleRow));
    }

    const onRemoveRole = (index: number) => {
        dispatch(setCreatorMode(CreatorMode.SetupRoleRow))
        removeRoleValue(index - 1, 2);
    }

    return <div className="mafia-container-wrapper">
        <div className="mafia-content">
            <SubHeader>Edit Role</SubHeader>
            {creatorMode === CreatorMode.SetupSingleRoleRow && getRoleSelector()}
            <div className="role-row-row">
                <div className="mafia-role-selector-header">Role (combination) is:</div>
                <div className="mafia-role-rows">
                    {roleArray.map((singleRow, index) => {
                        if (singleRow === '+' || singleRow === '-') {
                            return <div className="plus-minus-picker">
                                <div className={`plus-minus-button ${singleRow === '+' ? 'selected' : ''}`} onClick={() => onPlusClick(index)}>+</div>
                                <div className={`plus-minus-button ${singleRow === '-' ? 'selected' : ''}`} onClick={() => onMinusClick(index)}>-</div>
                            </div>
                        }
                        return <div className="row">
                            <button className="selected" onClick={() => onRoleClick(index)}>{singleRow}</button>
                            {index !== 0 && <button onClick={() => onRemoveRole(index)}>x</button>}
                        </div>
                    })}
                    <div className="plus-minus-picker">
                        <div className={`plus-minus-button`} onClick={() => onNewClick('+')}>+</div>
                        <div className={`plus-minus-button`} onClick={() => onNewClick('-')}>-</div>
                    </div>
                </div>
            </div>
        </div>
        <Footer>
            <button onClick={() => dispatch(setCreatorMode(CreatorMode.SetupRoles))}>Cancel</button>
            <button onClick={onSaveClick}>Save</button>
        </Footer>
    </div>
}

export default RoleRowSetup;